import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PaymentOfferBreakdownWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  border-radius: 16px;
  background: ${theme.whiteText};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const TitleDescriptionWrapper = styled.div`
  padding: 40px;
  flex-direction: column;
  gap: 20px;
  width: 550px;
  display: flex;
  width: 55%;
`;
export const SectionTitle = styled.div`
  font-size: 32px;
  font-weight: 900;
  color: ${theme.blackText};
`;

export const SectionDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #4a4a4a;
  margin-bottom: 24px;
  line-height: 1.5;
  width: 80%;
`;

export const OfferCardWrapper = styled.div`
  background-image: url("https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147224415_3x_138716eb84.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: auto;
  display: flex;
  gap: 17px;
  padding: 26px 0 26px 75px;
  position: relative;
  width: 45%;
`;

export const OfferCard = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0px 24px 0px ${theme.lightBlack};
  width: 303px;
  padding: 16px 12px;
`;

export const CardHeader = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
`;

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: ${theme.greyText};
`;

export const CardImage = styled.img`
  left: 275px;
  top: 25.5px;
  position: absolute;
  width: 303px;
  height: auto;
  object-fit: contain;
`;

export const AmountBreakdownList = styled.div`
  display: flex;
  flex-direction: column;
`;

interface AmountRowProps {
  bgColor?: string;
}

export const AmountRow = styled.div<AmountRowProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  padding: 8px;
  color: ${theme.greyText};
  background-color: ${(props) => props.bgColor || theme.whiteText};

  &:last-child {
    border-top: 1px solid ${theme.lightGrey};
  }
`;
